import { Fragment } from 'react';

type InterpolatedProps = {
	template: string;
	data: Record<string, string | number | JSX.Element>;
};

export const Interpolated = ({ template, data }: InterpolatedProps): JSX.Element => {
	var tokens = template.split(/\{\{|\}\}/);
	return (
		<>
			{tokens.map((token, i) => (
				<Fragment key={i}>
					<span className={[1, 3].includes(i) ? 'bold' : ''}>{i % 2 === 0 ? token : data[token]}</span>
				</Fragment>
			))}
		</>
	);
};
